@if (carregandoInicialCadastro) {
  <div class="cadastro-disparo cadastro-disparo--skeleton" aria-label="Carregando dados do disparo">
    <div class="paineis-disparo">
      <div class="painel painel-1">
        <div class="skeleton-card">
          <div class="skeleton-bloco skeleton-titulo-campo skeleton-titulo-campo--pequeno"></div>
          <div class="skeleton-bloco skeleton-input"></div>
          <div class="skeleton-rodape">
            <div class="skeleton-bloco skeleton-botao"></div>
            <div class="skeleton-bloco skeleton-botao"></div>
            <div class="skeleton-bloco skeleton-botao"></div>
          </div>
        </div>
      </div>

      <div class="painel painel-2">
        <div class="skeleton-card">
          <div class="skeleton-abas">
            <div class="skeleton-bloco skeleton-aba-tipo"></div>
            <div class="skeleton-bloco skeleton-aba-tipo"></div>
            <div class="skeleton-bloco skeleton-aba-tipo"></div>
          </div>
          <div class="skeleton-bloco skeleton-titulo-campo skeleton-titulo-campo--pequeno"></div>
          <div class="skeleton-bloco skeleton-input"></div>
          <div class="skeleton-bloco skeleton-preview"></div>
        </div>
      </div>

      <div class="painel painel-3">
        <div class="skeleton-card">
          <div class="skeleton-abas">
            <div class="skeleton-bloco skeleton-aba-origem"></div>
            <div class="skeleton-bloco skeleton-aba-origem"></div>
          </div>
          <div class="skeleton-linha skeleton-header">
            <div class="skeleton-bloco skeleton-titulo-campo skeleton-titulo-campo--pequeno"></div>
            <div class="skeleton-bloco skeleton-toggle"></div>
          </div>
          <div class="skeleton-tabela">
            <div class="skeleton-bloco skeleton-tabela-header"></div>
            <div class="skeleton-bloco skeleton-tabela-linha"></div>
            <div class="skeleton-bloco skeleton-tabela-linha"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
} @else if (ehMobile && disparoAutomatico.id && !exibirProgramacao) {
  <div class="area-card">
    <div class="header-card">
      <span class="titulo">{{ disparoAutomatico.tituloDisparo }}</span>

      <span [class]="'card-status ellipse ' + classeStatusDisparo(disparoAutomatico.status)">{{ disparoAutomatico.status }}</span>
    </div>

    @if (emProcessamento) {
      <div class="progresso-processamento"
        role="progressbar"
        aria-label="Progresso do disparo"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-valuenow]="progressoProcessamento">
        <div class="progresso-processamento__preenchimento" [style.width.%]="progressoProcessamento"></div>
        <div class="progresso-processamento__conteudo">
          <span>Processando...</span>
          <strong>({{ quantidadeContatosProcessados }}/{{ totalContatosProcessamento }})</strong>
          <strong>{{ progressoProcessamento }}%</strong>
        </div>
      </div>
    }

    @if (exibirMetricas) {
    <app-metricas [ehMobile]="ehMobile"
      [quantidadeEnviados]="disparoAutomatico.infos?.numEnviados ?? 0"
      [quantidadeRecebidos]="disparoAutomatico.infos?.numRecebidos ?? 0"
      [quantidadeLidos]="disparoAutomatico.infos?.numLidos ?? 0"
      [quantidadeErros]="disparoAutomatico.infos?.numErros ?? 0"
      [quantidadeBlacklist]="disparoAutomatico.infos?.numBlacklist ?? 0"
      [quantidadeInvalidos]="disparoAutomatico.infos?.numInvalidos ?? 0"
      [quantidadeEmProcessamento]="disparoAutomatico.infos?.numEmProcessamento ?? 0"
      [quantidadePorcentagemConversao]="disparoAutomatico.infos?.porcentConversao ?? 0"
      [quantidadePesquisasRespondidas]="disparoAutomatico.infos?.numPesquisasRespondidas ?? 0"
      [quantidadePorcentagemPesquisasRespondidas]="disparoAutomatico.infos?.porcentPesquisaRespondida ?? 0"
      [interacao]="disparoAutomatico.infos?.numRespondidos ?? 0"
      [possuemSessao]="disparoAutomatico.infos?.numPossuemSessao ?? 0"
      [custoDisparo]="disparoAutomatico.custoDisparo ?? 0"
      [moedaCusto]="disparoAutomatico.moedaCusto"
      [tipoDisparo]="disparoAutomatico.tipoDisparo"
      [isFluxoPesquisa]="disparoAutomatico.fluxo?.tipo === 'PESQUISA'"></app-metricas>
    }

    <!-- @if(mostraBtnReenvioInteg()) {
      <app-button-padrao
        label="Enviar integração novamente"
        backgroundColor="var(--primary)"
        color="white"
        [disabled]="reenviandoIntegracao"
        (buttonClick)="reenviarIntegracao()">
      </app-button-padrao>
    } -->

    <div class="detalhe-card">
      <div class="detalhe-item width-90">
        <span class="titulo">Template</span>
        <span class="item">{{ disparoAutomatico.template?.name ?? '--' }}</span>
      </div>

      <div class="detalhe-item width-90">
        <span class="titulo">Fluxo</span>
        <span class="item">{{ disparoAutomatico.fluxo?.nome ?? '--' }}</span>
      </div>

      <div class="detalhe-item">
        <span class="titulo">Data Envio</span>
        <span class="item">{{ (disparoAutomatico.dataEnvio | date:'dd/MM/yyyy') ?? '--' }}</span>
      </div>

      <div class="detalhe-item width-75">
        <span class="titulo">Horário Envio</span>
        <span class="item">{{ (disparoAutomatico.dataEnvio | date:'HH:mm') ?? '--' }}</span>
      </div>
    </div>

    <span class="body-titulo">Visualização da Mensagem</span>
    <div class="width-100 flex justify-center">
      <app-template-mensagem [style.width]="ehMobile ? '80%' : 'auto'" [tipo]="disparoAutomatico.tipoDisparo ?? 'Whatsapp'" [template]="disparoAutomatico.template!" [variaveis]="variaveis"></app-template-mensagem>
    </div>

    <span class="body-titulo" role="button" tabindex="0" (click)="abrirModalListaContatos()" (keydown.enter)="abrirModalListaContatos()">Lista de Contatos
      <img src="./assets/icones/visualizar.svg" alt="Visualizar" />
    </span>
  </div>
} @else {
  <div class="cadastro-disparo">

    @if (disparoAutomatico.id && !exibirProgramacao && emProcessamento) {
      <div class="progresso-processamento"
        role="progressbar"
        aria-label="Progresso do disparo"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-valuenow]="progressoProcessamento">
        <div class="progresso-processamento__preenchimento" [style.width.%]="progressoProcessamento"></div>
        <div class="progresso-processamento__conteudo">
          <span>Processando...</span>
          <strong>({{ quantidadeContatosProcessados }}/{{ totalContatosProcessamento }})</strong>
          <strong>{{ progressoProcessamento }}%</strong>
        </div>
      </div>
    }

    @if (disparoAutomatico.id && !exibirProgramacao && exibirMetricas) {
      <app-metricas
        [quantidadeEnviados]="disparoAutomatico.infos?.numEnviados ?? 0"
        [quantidadeRecebidos]="disparoAutomatico.infos?.numRecebidos ?? 0"
        [quantidadeLidos]="disparoAutomatico.infos?.numLidos ?? 0"
        [quantidadeErros]="disparoAutomatico.infos?.numErros ?? 0"
        [quantidadeBlacklist]="disparoAutomatico.infos?.numBlacklist ?? 0"
        [quantidadeInvalidos]="disparoAutomatico.infos?.numInvalidos ?? 0"
        [quantidadeEmProcessamento]="disparoAutomatico.infos?.numEmProcessamento ?? 0"
        [quantidadePorcentagemConversao]="disparoAutomatico.infos?.porcentConversao ?? 0"
        [quantidadePesquisasRespondidas]="disparoAutomatico.infos?.numPesquisasRespondidas ?? 0"
        [quantidadePorcentagemPesquisasRespondidas]="disparoAutomatico.infos?.porcentPesquisaRespondida ?? 0"
        [interacao]="disparoAutomatico.infos?.numRespondidos ?? 0"
        [possuemSessao]="disparoAutomatico.infos?.numPossuemSessao ?? 0"
        [custoDisparo]="disparoAutomatico.custoDisparo ?? 0"
        [moedaCusto]="disparoAutomatico.moedaCusto"
        [tipoDisparo]="disparoAutomatico.tipoDisparo"
        [isFluxoPesquisa]="disparoAutomatico.fluxo?.tipo === 'PESQUISA'"></app-metricas>
    }

    <div class="paineis-disparo">
      <app-disparo-info
        class="painel painel-1"
        [disparoAutomatico]="disparoAutomatico"
        [exibirProgramacao]="exibirProgramacao"
        [tipoProgramacao]="tipoProgramacao"
        [programacao]="programacao"
        [salvando]="salvando"
        [cadastroInvalido]="!!motivoIntegracaoInvalida"
        [motivoCadastroInvalido]="motivoIntegracaoInvalida"
        (envioDisparoAutomatico)="disparoAutomatico = $event"
        (tipoProgramacaoChange)="tipoProgramacao = $event"
        (programacaoChange)="programacao = $event"
        (salvar)="salvar()"
        (enviar)="enviarDisparoAutomatico()"
        (cancelar)="cancelarCadastro($event)"></app-disparo-info>

      <app-forma-envio
        class="painel painel-2"
        [disparoAutomatico]="disparoAutomatico"
        [setorId]="setorId"
        [anexo]="anexo"
        [listaContatos]="contatosPreview"
        [variaveis]="variaveis"
        [colunasComplementares]="colunasComplementares"
        [programacaoAtiva]="programacao.ativo !== false"
        (envioDisparoAutomatico)="disparoAutomatico = $event"
        (templateSelecionado)="variaveis = []"
        (variaveisCriadas)="receberVariaveis($event)"
        (variaveisEmailPendentes)="emailVariaveisPendentes = $event"></app-forma-envio>

      <app-lista-envio-contatos
        class="painel painel-3"
        [disparoAutomatico]="disparoAutomatico"
        [statusDisparo]="disparoAutomatico.status"
        [anexo]="anexo"
        [setorId]="setorId"
        [carregandoInicial]="carregandoContatos"
        [variaveis]="variaveis"
        [exibirReenvioIntegracao]="mostraBtnReenvioInteg()"
        [reenviandoIntegracao]="reenviandoIntegracao"
        (envioAnexo)="atualizarAnexo($event)"
        (colunasComplementaresAtualizadas)="atualizarColunasComplementares($event)"
        (contatosPreviewAtualizados)="atualizarContatosPreview($event)"
        (reenviarIntegracao)="reenviarIntegracao()"></app-lista-envio-contatos>
    </div>
  </div>
}
